<template>
  <div>
    <t-form
      :onSubmit="submitBillingAddress"
      id="billing_address_form"
      :schema="billingAddressSchema"
    >
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_contact_person)}}</span></div>
        <div class="input-content">
          <div style='width:45%' playwright-id='billing-first-name'>
            <t-input-text
              style="margin-right: 5px"
              v-model="billingAddress.first_name"
              :modelValue="billingAddress.first_name?billingAddress.first_name:customer.first_name"
              :placeholder="$translation($websiteText().my_profile_first_name)"
              name="first_name"
              :disabled = 'disabled'
            ></t-input-text>
          </div>
          <div style='width:45%' playwright-id='billing-last-name'>
            <t-input-text
              style=""
              v-model="billingAddress.last_name"
              :modelValue="billingAddress.last_name?billingAddress.last_name:customer.last_name"
              :placeholder="$translation($websiteText().my_profile_last_name)"
              name="last_name"
              :disabled = 'disabled'
            ></t-input-text>
          </div>
        
        </div>
      </div>
     
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_contact_email)}}</span></div>
        <div class="input-content" playwright-id="billing-email">
          <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.email"
            :modelValue="billingAddress.email?billingAddress.email:customer.email"
            placeholder="example@email.com"
            name="email"
            :disabled = 'disabled'
          ></t-input-text>
        </div>
      </div>

      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_phone_number)}}</span></div>
        <div class="input-content">
          <div style = "width:45%" playwright-id='billing-phone-dial'>
            <t-input-select
              style="margin-right: 5px;"
              :options="$store.getters.phoneCodes"
              :filter="true"
              optionValue="dial_code"
              optionLabel="dial_code"
              v-model="billingAddress.phone_dial"
              :displayError="true"
              optionLabel1="name"
              filterLabel='name'
              name="phone_dial"
              placeholder="+123"
              :disabled = 'disabled'
              :filterFields="['dial_code', 'name']"
            ></t-input-select>
          </div>
          <div style="width:45%" playwright-id='billing-phone-number'>
            <t-input-text
              
              v-model="billingAddress.phone_number"
              name="phone_number"
              :displayError="false"
              placeholder="01 23 45 67 89"
              :disabled = 'disabled'
            ></t-input-text>
          </div>
          
        </div>
      </div>

      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_address)}}</span></div>
        <div class="input-content" playwright-id='billing-address'>
          <t-input-text
            rootStyle="width:inherit"
            id="locationTextField"
            v-model="billingAddress.address"
            :placeholder="$translation($websiteText().my_profile_address_placeholder)"
            name="address"
            style="width: 100%"
            @input="init()"
            :autocomplete="'off'"
            :ariaAutocomplete="'none'"
            :disabled = 'disabled'
          ></t-input-text>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_company)}}</span></div>
        <div class="input-content" playwright-id='billing-company'>
          <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.company_name"
            :placeholder="$translation($websiteText().my_profile_company)"
            name="company_name"
            :disabled = 'disabled'
          ></t-input-text>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_street)}}</span></div>
        <div class="input-content" playwright-id='billing-street'>
          <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.street_name"
            name="street_name"
            :placeholder="$translation($websiteText().my_profile_street)"
            :disabled = 'disabled'
          ></t-input-text>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_zip)}}</span></div>
        <div class="input-content" playwright-id='billing-zip-code'>
          <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.zip"
            name="zip"
            :placeholder="$translation($websiteText().my_profile_zip)"
            :disabled = 'disabled'
          ></t-input-text>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_country)}}</span></div>
        <div class="input-content" playwright-id='billing-country'>
          <!-- <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.country"
            name="country"
            :placeholder="$translation($websiteText().my_profile_country)"
            :disabled='false'
          ></t-input-text> -->

          <t-input-select
            style="margin-right: 5px;"
            :options="$store.getters.apiCountries"
            :filter="true"
            optionValue="name"
            v-model="billingAddress.country"
            :displayError="true"
            optionLabel1="iso2"
            filterLabel='name'
            name="country"
            :placeholder="$translation($websiteText().my_profile_country)"
            :disabled = 'false'
            :filterFields="['iso2', 'name']"
            :changeAction="getStates"
            
          ></t-input-select>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_state)}}</span></div>
        <div class="input-content" playwright-id='billing-state'>
          <!-- <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.state"
            name="state"
            :placeholder="$translation($websiteText().my_profile_state)"
            :disabled = 'false'
          ></t-input-text> -->
          <t-input-select
            style="margin-right: 5px;"
            :options="$store.getters.statesByCountry"
            :filter="true"
            optionValue="name"
            v-model="billingAddress.state"
            :displayError="true"
            optionLabel1="iso2"
            filterLabel='name'
            name="state"
            :placeholder="$translation($websiteText().my_profile_state)"
            :disabled = 'false'
            :filterFields="['iso2', 'name']"
            :changeAction="getCities"
          ></t-input-select>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_city)}}</span></div>
        <div class="input-content" playwright-id='billing-city'>
          <!-- <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.city"
            name="city"
            :placeholder="$translation($websiteText().my_profile_city)"
            :disabled = 'false'
          ></t-input-text> -->

          <t-input-select
            style="margin-right: 5px;"
            :options="$store.getters.citiesbyState"
            :filter="true"
            optionValue="name"
            v-model="billingAddress.city"
            :displayError="true"
            optionLabel1="iso2"
            filterLabel='name'
            name="city"
            :placeholder="$translation($websiteText().my_profile_city)"
            :disabled = 'false'
            :filterFields="['name']"
            
          ></t-input-select>
        </div>
      </div>
      <div class="dashboard-row">
        <div class="input-title"><span>{{$translation($websiteText().my_profile_vat)}}</span></div>
        <div class="input-content">
          <t-input-text
            rootStyle="width:inherit"
            v-model="billingAddress.vat_number"
            :placeholder="$translation($websiteText().my_profile_vat)"
            name="vat_number"
            @keyup="validateVatNumber"
            :disabled = 'disabled'
          ></t-input-text>

          <i
            v-if="vatValidated.value == true"
            style="color:green; margin-top:10px; margin-left:10px"
            class="pi pi-check"
          ></i>
          <i
            v-if="vatValidated.value == false"
            style="color:red; margin-top:10px; margin-left:10px"
            class="pi pi-times"
          ></i>
        </div>
      </div>
      <div class="dashboard-row" playwright-id='billing-save-button'>
        <t-button
          :color="'primary-color'"
          v-if="showSave == true"
          style="margin-left: auto"
          :label="$translation($websiteText().website_generals_save_btn)"
          type="submit"
          formSubmit="billing_address_form"
          :onClick="submitValidate"
        />
      </div>
    </t-form>
  </div>
</template>

<script>
import { reactive } from "@vue/reactivity";
import TInputText from "../../../../common/components/input-text/TInputText.vue";
import TInputSelect from "../../../../common/components/input-text/TInputSelect.vue";
import TForm from "../../../../common/components/TForm.vue";
import TButton from "../../../../common/components/buttons/TButton.vue";
import * as Yup from "yup";
import store from "../../../../store";
import {
  CREATE_BILLING_ADDRESS,
  UPDATE_BILLING_ADDRESS,
  VALIDATE_VAT,
} from "../../store/customer/actions";
import GooglePlacesHelper from "../../../../common/helpers/GooglePlacesHelper";
import { SET_API_COUNTRIES, SET_CITIES_BY_STATES, SET_STATES_BY_COUNTRY, SHOW_TOAST_MESSAGE } from "../../../../common/store/actions";
import GeneralHelper from "../../../../common/helpers/GeneralHelper";
import phoneCodes from "../../../../common/store/phoneCodes";
export default {
  components: {
    TInputText,
    TInputSelect,
    TForm,
    TButton,
  },

  data() {
    return {
      countries:[],
      countryIso2: null,
      states:[],
      cities: [],
    }
  },
  mounted() {
    this.$store.dispatch(SET_API_COUNTRIES).then(()=>{
      this.countries = this.$store.getters.apiCountries;
      
    })
    // this.init();
  },

  watch: {
    'billingAddress.country': async function (newValue, oldValue) {
      await this.getStates(newValue);
    },

    'billingAddress.state': async function (newValue, oldValue) {
      await this.getStates(this.billingAddress.country);
      this.getCities(newValue);
    },
  },

  methods: {
    getStates(countryName) {
    
      const country = this.countries.find(c => c.name === countryName);
      if (!country) return;
      this.countryIso2 = country.iso2;
      return this.$store.dispatch(SET_STATES_BY_COUNTRY, country.iso2).then(() => {
        this.states = this.$store.getters.statesByCountry;
        
      });
    },

    getCities(stateName){
 
      const state = this.states.find(s => s.name === stateName);
      
      if (!state) return;
      return this.$store.dispatch(SET_CITIES_BY_STATES, {
        countryCode: this.countryIso2,
        stateCode: state.iso2
      }).then(() => {
        this.cities = this.$store.getters.citiesbyState;
        console.log("cities", this.cities);
      });
    }

    
  },
  computed: {
  customer() {
    return this.$store.getters.customer;
  }
},
  setup(props, { emit }) {
    let billingAddress = reactive(props.data_);
    let autocomplete = null;

    const init = () => {
      var input = document.getElementById("locationTextField");
      if(!autocomplete) 
      {
        autocomplete = new google.maps.places.Autocomplete(input)
        google.maps.event.addListener(autocomplete, "place_changed", function() {
          var place = autocomplete.getPlace();
          if (place.business_status) {
            billingAddress.company_name = place.name
          }
          if(place.international_phone_number){
            for(var i = 0; i < place.address_components.length; i++) {
              var addressObj = place.address_components[i];
              for(var j = 0; j < addressObj.types.length; j++) {
                if (addressObj.types[j] === 'country') {
                  billingAddress.phone_dial = phoneCodes.find(phoneCode=>phoneCode.name==addressObj.long_name).dial_code
                  billingAddress.phone_number = place.formatted_phone_number
                  break
                }
              }
            } 
          }
          var details = GooglePlacesHelper.extract(place.address_components);
          console.log("details", details);

          billingAddress.street_name = (details.route||"").trim();
          billingAddress.country = (details.country||"").trim();
          billingAddress.zip = (details.zip||"").trim();
          billingAddress.address = (place.formatted_address||"").trim()

        store.dispatch(SET_API_COUNTRIES).then(() => {
          const countries = store.getters.apiCountries;
          const country = countries.find((c) => c.name === details.country);
          console.log("country", country);

          if (!country) return;

          const countryIso2 = country.iso2;
          billingAddress.country = country.name;

          store.dispatch(SET_STATES_BY_COUNTRY, countryIso2).then(() => {
            const states = store.getters.statesByCountry;
            console.log("states", states);
            billingAddress.state = (details.state || "").trim();

            const state = states.find((s) => s.name === details.state);
            if (!state) return;

            store
              .dispatch(SET_CITIES_BY_STATES, {
                countryCode: countryIso2,
                stateCode: state.iso2,
              })
              .then(() => {
                const cities = store.getters.citiesbyState;
                console.log("cities", cities);
                billingAddress.city = (details.city || "").trim();
              });
          });
        });
          
         
        });

        input.addEventListener('blur', function (){
          setTimeout(function (){
  
            var service = new google.maps.places.AutocompleteService();
            service.getPlacePredictions({ input: input.value }, predictionsCallback);
            function predictionsCallback(predictions, status) {
              if (status != google.maps.places.PlacesServiceStatus.OK) return;
              
              let place_id = predictions[0].place_id
              const geocoder = new google.maps.Geocoder();
              geocoder
              .geocode({ placeId: place_id })
              .then(({ results }) => {
                if (results[0]) {
                  var details = GooglePlacesHelper.extract(results[0].address_components);
                  billingAddress.street_name = (details.route||"").trim();
                  billingAddress.country = (details.country||"").trim();
                  billingAddress.zip = (details.zip||"").trim();
                  billingAddress.state = (details.state||"").trim();
                  billingAddress.city = (details.city||"").trim();
                  billingAddress.address = (results[0].formatted_address||"").trim()
                } else {
                  window.alert("No results found");
                }
              })
              .catch((e) => window.alert("Geocoder failed due to: " + e));

              }
                      
          }, 500);
          
        })
      }
    };
    const billingAddressSchema = Yup.object().shape({
      first_name: Yup.string()
        .required()
        .label("First name"),
      last_name: Yup.string()
        .required()
        .label("Last name"),
      email: Yup.string()
        .required()
        .label("Email")
        .email("Invalid email format"),
      phone_dial: Yup.string()
        .required()
        .label("Phone dial"),
      phone_number: Yup.string()
        .required()
        .label("Phone number"),
      address: Yup.string()
        .required()
        .label("Address"),
      city: Yup.string()
        .required()
        .label("City"),
      country: Yup.string()
        .required()
        .label("Country"),
      state: Yup.string()
        .required()
        .label("State"),
      street_name: Yup.string()
        .required()
        .label("Street"),
      zip: Yup.string()
        .required()
        .label("ZIP Code"),
    });

    const submitValidate = () => {
      billingAddressSchema
        .validate(billingAddress, { abortEarly: false })
        .then()
        .catch((e) => {
          for (let i = 0; i < e.errors.length; i++) {
            store.dispatch(
              SHOW_TOAST_MESSAGE,
              GeneralHelper.buildMessage(3, e.errors[i])
            );
          }
        });
    };
    const submitBillingAddress = () => {
      billingAddressSchema.isValid(billingAddress).then(function(valid) {
        if (!props.showSave) emit("validated", valid);
      });
      if (props.showSave) {
        if (store.getters.billingAddress.id != undefined)
          store
            .dispatch(UPDATE_BILLING_ADDRESS, billingAddress)
            .then()
            .catch((e) => {
              if (e.response && e.response.data) {
                store.dispatch(
                  SHOW_TOAST_MESSAGE,
                  GeneralHelper.buildMessage(3, e.response.data.message)
                );
              }
            });
        else
          store
            .dispatch(CREATE_BILLING_ADDRESS, billingAddress)
            .then()
            .catch((e) => {
              if (e.response && e.response.data) {
                store.dispatch(
                  SHOW_TOAST_MESSAGE,
                  GeneralHelper.buildMessage(3, e.response.data.message)
                );
              }
            });
      }
    };
    let timeout = undefined;
    let vatValidated = reactive({});
    const validateVatNumber = () => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        store
          .dispatch(VALIDATE_VAT, {
            vat_number: billingAddress.vat_number,
          })
          .then((result) => {
            vatValidated.value = result.data.valid;
            if (result.data.valid)
              store.dispatch(
                SHOW_TOAST_MESSAGE,
                GeneralHelper.buildMessage(1, "VAT validated ")
              );
            else
              store.dispatch(
                SHOW_TOAST_MESSAGE,
                GeneralHelper.buildMessage(3, "Invalid VAT number ")
              );
          })
          .catch((e) => {
            if (e.response && e.response.data) {
              store.dispatch(
                SHOW_TOAST_MESSAGE,
                GeneralHelper.buildMessage(3, e.response.data.message)
              );
            }
          });
      }, 1000);
    };

    return {
      submitValidate,
      submitBillingAddress,
      billingAddressSchema,
      billingAddress,
      init,
      validateVatNumber,
      vatValidated,
    };
  },

  props: {
    data_: {
      default: {},
    },
    showSave: {
      default: true,
    },
    disabled: {
      default: false,
    },
  },
};
</script>

<style lang="scss">

@import '../../style/profile.scss';
@media screen and (max-width:500px) {
  .p-dropdown-panel{
    width: 200px !important;
    min-width: 200px !important;
  }
  
  .p-dropdown-panel.p-dropdown-header{
    height: 30px !important;
    padding: 5px !important;
  }
}
.p-dropdown-filter.p-inputtext{
  height: 20px !important;
}

.p-dropdown-label{
  align-items: baseline !important;
}

.p-dropdown-item {
  padding: 5px !important;
  font-size: 13px !important;
}

</style>
